import React, { useEffect } from 'react';

const ZoneLandingPage: React.FC = () => {
  useEffect(() => {
    if (process.env.REACT_APP_APP_URL) {
      window.location.href = process.env.REACT_APP_APP_URL;
    }
  }, []);

  return <></>;
};

export default ZoneLandingPage;
